import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.less']
})
export class AuditLogsComponent implements OnInit {

  isSuperAdmin: boolean = false;

  constructor(private _notify:NotificationService,private commonServices: CommonDataService) {
    if(this.commonServices.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID
      || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.IT_READ_ONLY_ROLE_ID){
      this.isSuperAdmin=true;
    }
  }


  ngOnInit(): void {
  }
  
  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('publish-history');
  }

}
